import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const MansionIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-mansion"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M52,18 L16,18 C14.8957153,18 14,18.8957153 14,20 L14,28 C14,29.1042847 14.8957153,30 16,30 L52,30 C53.1042847,30 54,29.1042847 54,28 L54,20 C54,18.8957153 53.1042847,18 52,18 Z M16,20 L52,20 L52,28 L16,28 L16,20 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M48,8 L20,8 C18.8957153,8 18,8.89571525 18,10 L18,18 C18,19.1042847 18.8957153,20 20,20 L48,20 C49.1042847,20 50,19.1042847 50,18 L50,10 C50,8.89571525 49.1042847,8 48,8 Z M20,10 L48,10 L48,18 L20,18 L20,10 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#ffffff"
          className={styles.white}
          points="25.5 33.5 42.5 33.5 42.5 31.5 25.5 31.5"
        />
        <path
          d="M43,31 L25,31 L25,34 L43,34 L43,31 Z M42,32 L42,33 L26,33 L26,32 L42,32 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#ffffff"
          className={styles.white}
          points="27.5 31.5 40.5 31.5 40.5 29.5 27.5 29.5"
        />
        <path
          d="M41,29 L27,29 L27,32 L41,32 L41,29 Z M40,30 L40,31 L28,31 L28,30 L40,30 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#ffffff"
          className={styles.white}
          points="29.5 29.5 38.5 29.5 38.5 27.5 29.5 27.5"
        />
        <path
          d="M39 27 29 27 29 30 39 30 39 27ZM38 28 38 29 30 29 30 28 38 28ZM33.5527864.105572809 17.5527864 8.10557281C16.608965 8.57748352 16.9447756 10 18 10L50 10C51.0552244 10 51.391035 8.57748352 50.4472136 8.10557281L34.4472136.105572809C34.1656861-.0351909363 33.8343139-.0351909363 33.5527864.105572809ZM34 2.118 45.764 8 22.235 8 34 2.118ZM49 17 49 19C49 19.5522847 49.4477153 20 50 20L54 20C55.0552244 20 55.391035 18.5774835 54.4472136 18.1055728L50.4472136 16.1055728C49.7823125 15.7731223 49 16.256618 49 17Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="32 27 36 27 36 21 32 21"
        />
        <path
          d="M25.5 11 21.5 11C21.2238576 11 21 11.2238576 21 11.5L21 16.5C21 16.7761424 21.2238576 17 21.5 17L25.5 17C25.7761424 17 26 16.7761424 26 16.5L26 11.5C26 11.2238576 25.7761424 11 25.5 11ZM25 12 25 16 22 16 22 12 25 12ZM46.5 11 42.5 11C42.2238576 11 42 11.2238576 42 11.5L42 16.5C42 16.7761424 42.2238576 17 42.5 17L46.5 17C46.7761424 17 47 16.7761424 47 16.5L47 11.5C47 11.2238576 46.7761424 11 46.5 11ZM46 12 46 16 43 16 43 12 46 12ZM40.5 11 36.5 11C36.2238576 11 36 11.2238576 36 11.5L36 16.5C36 16.7761424 36.2238576 17 36.5 17L40.5 17C40.7761424 17 41 16.7761424 41 16.5L41 11.5C41 11.2238576 40.7761424 11 40.5 11ZM40 12 40 16 37 16 37 12 40 12ZM31.5 11 27.5 11C27.2238576 11 27 11.2238576 27 11.5L27 16.5C27 16.7761424 27.2238576 17 27.5 17L31.5 17C31.7761424 17 32 16.7761424 32 16.5L32 11.5C32 11.2238576 31.7761424 11 31.5 11ZM31 12 31 16 28 16 28 12 31 12ZM50.5 21 46.5 21C46.2238576 21 46 21.2238576 46 21.5L46 26.5C46 26.7761424 46.2238576 27 46.5 27L50.5 27C50.7761424 27 51 26.7761424 51 26.5L51 21.5C51 21.2238576 50.7761424 21 50.5 21ZM50 22 50 26 47 26 47 22 50 22ZM44.5 21 40.5 21C40.2238576 21 40 21.2238576 40 21.5L40 26.5C40 26.7761424 40.2238576 27 40.5 27L44.5 27C44.7761424 27 45 26.7761424 45 26.5L45 21.5C45 21.2238576 44.7761424 21 44.5 21ZM44 22 44 26 41 26 41 22 44 22ZM21.5 21 17.5 21C17.2238576 21 17 21.2238576 17 21.5L17 26.5C17 26.7761424 17.2238576 27 17.5 27L21.5 27C21.7761424 27 22 26.7761424 22 26.5L22 21.5C22 21.2238576 21.7761424 21 21.5 21ZM21 22 21 26 18 26 18 22 21 22ZM27.5 21 23.5 21C23.2238576 21 23 21.2238576 23 21.5L23 26.5C23 26.7761424 23.2238576 27 23.5 27L27.5 27C27.7761424 27 28 26.7761424 28 26.5L28 21.5C28 21.2238576 27.7761424 21 27.5 21ZM27 22 27 26 24 26 24 22 27 22Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon fill="#ffffff" className={styles.white} points="25 5 21 7.506 21 1 25 1" />
        <path
          d="M25,0 L21,0 C20.4477153,0 20,0.44771525 20,1 L20,7.506 C20,8.29191961 20.8649036,8.77068122 21.5309127,8.35342651 L25.5309127,5.84742651 C25.8227721,5.66457661 26,5.34440672 26,5 L26,1 C26,0.44771525 25.5522847,0 25,0 Z M24,2 L24,4.446 L22,5.699 L22,2 L24,2 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon fill="#ffffff" className={styles.white} points="43 5 47 7.506 47 1 43 1" />
        <path
          d="M47,0 L43,0 C42.4477153,0 42,0.44771525 42,1 L42,5 C42,5.34440672 42.1772279,5.66457661 42.4690873,5.84742651 L46.4690873,8.35342651 C47.1350964,8.77068122 48,8.29191961 48,7.506 L48,1 C48,0.44771525 47.5522847,0 47,0 Z M46,2 L46,5.699 L44,4.446 L44,2 L46,2 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
